var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-login" }, [
    _c("div", { staticClass: "page-login--layer" }, [
      _c(
        "div",
        {
          staticClass: "page-login--content",
          attrs: { flex: "dir:top main:justify cross:stretch box:justify" }
        },
        [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "page-login--content-main",
              attrs: { flex: "dir:top main:center cross:center" }
            },
            [
              _c("div", { staticClass: "login-content" }, [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "page-login--form" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "loginForm",
                        attrs: {
                          "label-position": "top",
                          rules: _vm.rules,
                          model: _vm.formLogin,
                          size: "default"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "username" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "text",
                                "prefix-icon": "el-icon-user-solid",
                                placeholder: _vm.$t(
                                  "page.login.placeholder.username"
                                )
                              },
                              model: {
                                value: _vm.formLogin.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.formLogin, "username", $$v)
                                },
                                expression: "formLogin.username"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "password",
                                "prefix-icon": "el-icon-unlock",
                                placeholder: _vm.$t(
                                  "page.login.placeholder.password"
                                )
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.submit.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.formLogin.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.formLogin, "password", $$v)
                                },
                                expression: "formLogin.password"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "button-login",
                            attrs: { loading: _vm.loading, size: "default" },
                            on: { click: _vm.submit }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("page.login.button.login")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("p", {
                      staticClass: "page-login--options",
                      attrs: { flex: "main:justify cross:center" }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("div", { staticClass: "page-login--content-footer" }, [
            _c(
              "p",
              { staticClass: "page-login--content-footer-locales" },
              _vm._l(_vm.$languages, function(language) {
                return _c(
                  "a",
                  {
                    key: language.value,
                    on: {
                      click: function($event) {
                        return _vm.onChangeLocale(language.value)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(language.label) + " ")]
                )
              }),
              0
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-login--content-header" }, [
      _c("img", {
        staticClass: "decorate",
        attrs: { src: require("./image/login/元素1.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-wrap" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/JGlogo-min.png"), alt: "" }
      }),
      _c("span", [_vm._v("SRM 供应商管理平台")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }